import {Component, OnInit} from '@angular/core';
import {UserService} from '../../shared';
import {TrackingService} from '../../shared/services/tracking.service';
import {TrackingAction, TrackingCategory} from '../../shared/model/tracking/tracking.enum';

@Component({
    selector: 'jhi-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    joinedUserClub: boolean;

    constructor(private userService: UserService,
                private trackingService: TrackingService) {
    }

    ngOnInit() {
        this.userService.auth2Observable.subscribe(isUserAuthenticated => {
            if (!isUserAuthenticated) {
                this.joinedUserClub = true;
            }else {
                this.userService.getIsUserClubMember().then(isUserClubMember => {
                    this.joinedUserClub = isUserClubMember;
                }).catch(() => {
                    this.joinedUserClub = true;
                });
            }
        })
    }

    trackCliquer() {
      this._track(TrackingAction.CLIQUER);
    }

    private _track(action: TrackingAction) {
      this.trackingService.trackEvent({
        action,
        properties: {
          category: TrackingCategory.FOOTER,
          name: 'Mise à jour du site'
        }
      });
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/footer.component.ts